import api from './api';

const nextlaneApi = {
  getConcessions: (concessionId) => api.get('/nextlane/concessions' + (concessionId ? `?concession_id=${concessionId}` : '')),
  search: (q, mode, dealershipId, signal) => api.get('/nextlane/search', { params: { q, mode, dealershipId }, signal }),
  getStats: () => api.get('/nextlane/stats'),
  sync: () => api.post('/nextlane/sync'),

  // OR Atelier
  getORList: (params) => api.get('/nextlane-or', { params }),
  getORStats: () => api.get('/nextlane-or/stats'),
  getORDetail: (id) => api.get(`/nextlane-or/${id}`),
  getORDepartments: () => api.get('/nextlane-or/departments'),
  syncOR: () => api.post('/nextlane-or/sync'),

  // Workshop Appointments (push vers Nextlane)
  pushAppointment: (interventionId) => api.post(`/nextlane-appointments/push/${interventionId}`),
  getStandardCodes: (dealershipId) => api.get(`/nextlane-appointments/standard-codes/${dealershipId}`),

  // Reporting Factures Atelier
  getInvoiceKpis: (params) => api.get('/nextlane-invoices/kpis', { params }),
  getInvoiceDepartments: () => api.get('/nextlane-invoices/departments'),
  getInvoiceDealerships: () => api.get('/nextlane-invoices/dealerships'),
  syncInvoices: () => api.post('/nextlane-invoices/sync'),
};

export default nextlaneApi;
